import { z } from 'zod';

export const copyConditionsSchema = z.object({
  source_user_id: z.number().int().positive('Select a user to copy from'),
  condition_ids: z.array(z.number().int().positive()).min(1, 'Select at least one condition'),
});

export type CopyConditionsFormValues = z.infer<typeof copyConditionsSchema>;
